export default {
  zh: {
    resetTitle: '重置密码',
    chang: '修改密码',
    succeed: '重置密码成功'
  },
  en: {
    resetTitle: 'Reset passwords',
    chang: 'Change password',
    succeed: 'Password changed successfully'
  }
}
